import { useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { HistoryAttachment } from 'types';
import * as S from './styles';

interface Props {
  attachments: HistoryAttachment[];
}

const ICON_SIZE = 35;
const PREVIOUS = -1;
const NEXT = 1;

export function Attachments({ attachments }: Props) {
  const [currentImage, setCurrentImage] = useState(0);
  const { url, fileName } = attachments[currentImage];

  function getNewPosition(value: number) {
    const firstPosition = 0;
    const lastPosition = attachments.length - 1;

    const newPosition = currentImage + value;

    if (newPosition < firstPosition) return lastPosition;

    if (newPosition > lastPosition) return firstPosition;

    return newPosition;
  }

  function changeImage(value: number) {
    const newPosition = getNewPosition(value);

    setCurrentImage(newPosition);
  }

  return (
    <S.Main $singleAttachment={attachments.length === 1}>
      <S.Button onClick={() => changeImage(PREVIOUS)}>
        <IoIosArrowBack size={ICON_SIZE} />
      </S.Button>

      <S.Figure>
        <img src={url} alt={fileName} />
      </S.Figure>

      <S.Button onClick={() => changeImage(NEXT)}>
        <IoIosArrowForward size={ICON_SIZE} />
      </S.Button>
    </S.Main>
  );
}
